module.exports = __webpack_public_path__ + "img/ic_ig.386a500d.svg";